var map = {
	"./bnb.svg": "494c",
	"./busd.svg": "0960a",
	"./chart.svg": "1446",
	"./dai.svg": "a1e6",
	"./discord.svg": "3137",
	"./eth.svg": "5c04",
	"./medium.svg": "4626",
	"./metamask-fox.svg": "7535",
	"./osmo.svg": "5d61",
	"./paypal.svg": "c24a",
	"./sct.svg": "b02e",
	"./telegram.svg": "8f34",
	"./twitter.svg": "7f26",
	"./usdc.svg": "a161",
	"./usdt.svg": "d4db"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "af8c";